import React from 'react';
// import { Card, Layout, Row, Col } from 'antd';
import { connect } from 'react-redux';
// import classNames from 'classnames';
// import Logo from '../../images/logo-full.svg';
// import AuthMiddle from '../../images/auth-middle.svg';
// import styles from './styles.module.scss';
import './styles.scss';
import { withRouter } from 'react-router';
import { signOutUser } from '../../store/auth/actions';

class AuthContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.props.signOutUser();
  }

  render() {
    // const { children, match } = this.props;
    // const bodyStyle = {
    //   padding: 0
    // };
    return (
      <div />
      // <Layout className="authContainer">
      //   <Row className={styles.layout}>
      //     <Col
      //       className={styles.colWrapper}
      //       sm={20}
      //       xs={22}
      //       md={20}
      //       lg={match.path === '/:lang/signup' ? 16 : 12}
      //     >
      //       <Card
      //         className={classNames(styles.bottomBoxShadow, styles.card)}
      //         bodyStyle={bodyStyle}
      //       >
      //         <Row type="flex">
      //           <Col className={styles.leftCol} xs={0} lg={12}>
      //             <div
      //               style={{
      //                 height: '100%',
      //                 display: 'flex',
      //                 flexDirection: 'column',
      //                 justifyContent: 'space-between'
      //               }}
      //             >
      //               <p
      //                 style={{
      //                   textAlign: 'left',
      //                   marginBottom: 0,
      //                   padding: 30,
      //                   flexGrow: '0.7'
      //                 }}
      //               >
      //                 <img src={Logo} alt="Logo" style={{ height: '40px' }} />
      //               </p>
      //               <div
      //                 style={{
      //                   textAlign: 'center',
      //                   flexGrow: 3
      //                 }}
      //               >
      //                 <h2 style={{ fontWeight: 'lighter' }}>
      //                   Manage everyone easily!
      //                 </h2>
      //                 <img
      //                   src={AuthMiddle}
      //                   alt="Auth Middle"
      //                   style={{ width: '80%' }}
      //                 />
      //               </div>
      //               <p
      //                 style={{
      //                   textAlign: 'right',
      //                   color: '#fff',
      //                   fontSize: '15px',
      //                   marginBottom: 0
      //                 }}
      //               >
      //                 {/* <span>Bulk Messaging Simplified</span> */}
      //               </p>
      //             </div>
      //           </Col>
      //           <Col className={styles.rightCol} xs={24} lg={12}>
      //             {children}
      //           </Col>
      //         </Row>
      //       </Card>
      //       <div />
      //     </Col>
      //   </Row>
      // </Layout>
    );
  }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({
  signOutUser: () => {
    dispatch(signOutUser());
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AuthContainer));
